"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.StrategyOrder = void 0;

var _pragma = require("../../../pragma");

var React = _interopRequireWildcard(require("react"));

var _nanoid = require("nanoid");

var _ = require("../..");

var css = _interopRequireWildcard(require("./StrategyOrder.style"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const StrategyOrder = /*#__PURE__*/React.forwardRef(({
  scripName = '',
  metaTextLeft = '',
  options,
  isSelected = false,
  trend,
  failedText,
  parentOrderTypeText,
  onClick
}, ref) => {
  const isSomeFailed = options.some(item => item.statusInfo === 'Failed');
  return (0, _pragma.createFelaElement)(_.Card, {
    ref: ref,
    width: "full"
  }, (0, _pragma.createFelaElement)(_.View, {
    flex: true,
    flexDirection: "column",
    onClick: onClick,
    css: css.clickableWrapper
  }, (0, _pragma.createFelaElement)(_.View, {
    justifyContent: "space-between",
    alignItems: "center",
    padding: [12],
    css: css.orderContainer
  }, (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    gap: "xxsmall",
    justifyContent: "center"
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "heading3",
    color: "text.1",
    align: "left"
  }, scripName), (0, _pragma.createFelaElement)(_.View, {
    gap: "xxsmall",
    alignItems: "center"
  }, (0, _pragma.createFelaElement)(_.Text, {
    variant: "meta",
    color: "text.2",
    align: "left"
  }, metaTextLeft), trend, (0, _pragma.createFelaElement)(_.Tag, {
    variant: "greyInverse",
    transform: "none"
  }, parentOrderTypeText))), (0, _pragma.createFelaElement)(_.ButtonIcon, {
    variant: "invisible"
  }, (0, _pragma.createFelaElement)(_.ChevronRightIcon, {
    size: "small",
    color: "text.2"
  }))), (0, _pragma.createFelaElement)(_.View, {
    flexDirection: "column",
    padding: [12],
    css: css.optionContainer,
    cssProps: {
      isSelected
    }
  }, options.map((item, index) => (0, _pragma.createFelaElement)(_.StrategyOrderCell, {
    key: (0, _nanoid.nanoid)(),
    option: item,
    isLast: options.length === index + 1
  })), isSomeFailed && (0, _pragma.createFelaElement)(React.Fragment, null, (0, _pragma.createFelaElement)(_.Divider, {
    color: "background.tan"
  }), (0, _pragma.createFelaElement)(_.View, {
    flex: true,
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "small",
    padding: [12, 0, 8]
  }, (0, _pragma.createFelaElement)(_.ErrorCircleIcon, {
    color: "background.yellow",
    size: "large"
  }), failedText)))));
});
exports.StrategyOrder = StrategyOrder;
var _default = StrategyOrder;
exports.default = _default;
//# sourceMappingURL=StrategyOrder.js.map